<template>
  <div id="app">
    <Header/>
    <router-view/>
    <Footer/>
  </div>
</template>

<style lang="scss">
@import url('//fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;500;700&display=swap');

html {
  background: #000;
  font: 400 1.207vw / 1 'Noto Sans JP', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', 'Hiragino Sans', 'Hiragino Kaku Gothic ProN', 'メイリオ', Osaka, 'MS PGothic', sans-serif;
  @media (min-width: 829px) {
    font-size: 42%;
  }
  @media (min-width: 950px) {
    font-size: 48%;
  }
  @media (min-width: 1080px) {
    font-size: 55%;
  }
  @media (min-width: 1180px) {
    font-size: 62.5%;
  }
}

body {
  font-size: 2.8rem;
  -webkit-text-size-adjust: 100%;
  @media (min-width: 829px) {
    font-size: 1.8rem;
    margin: 0 auto;
    max-width: 1920px;
  }
}

main {
  display: block;
  overflow: hidden;
}

p {
  color: #fff;
  line-height: 1.5;
}

a {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  &:hover {
    @media (min-width: 829px) {
      text-decoration: none;
    }
  }
}

picture,
img {
  display: block;
  width: 100%;
}

::selection{
  background: rgba(126, 74, 213, .5);
}
</style>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'app',
  components: {
    Header,
    Footer
  },
  mounted: function () {
    const routeInstance = this.$route;
    this.createTitleDescription(routeInstance);
  },
  watch: {
    '$route' (routeInstance, from) {
      this.createTitleDescription(routeInstance);
    }
  },
  methods: {
    createTitleDescription: function (routeInstance) {
      if (routeInstance.meta.title) {
        const setTitle = routeInstance.meta.title;
        document.title = setTitle;
      } else {
        document.title = 'リネージュ2 レボリューション';
      }
      if (routeInstance.meta.description) {
        const setDescription = routeInstance.meta.description;
        document.querySelector('meta[property$="description"]').setAttribute('content', setDescription);
        document.querySelector('meta[name$="description"]').setAttribute('content', setDescription);
      } else {
        document.querySelector('meta[name="description"]').setAttribute('content', 'リネージュ2 レボリューション特設サイト。');
      }
      if (routeInstance.meta.image) {
        const setImage = routeInstance.meta.image;
        document.querySelector('meta[property$="image"]').setAttribute('content', setImage);
        document.querySelector('meta[name$="image"]').setAttribute('content', setImage);
      } else {
        document.querySelector('meta[property="og:image"]').setAttribute('content', 'https://l2.netmarble.jp/event/4th-anniversary/img/ogp.jpg');
      }
    }
  }
}
</script>
